<template>
	<div class="free-products insicht insicht--fade-up">
		<template v-if="loaded && !showSuccess && !notFound">
			<h2
				v-if="introTitle"
				class="free-products__title text-block__title"
				v-html="introTitle"
			/>
			<div
				v-if="introText"
				class="free-products__text text-block__text"
				v-html="introText"
			/>

			<template v-if="isLoggedIn">
				<div class="free-products__user">
					<span
						class="free-products__user-greeting"
						v-html="$t('freeproducts.userGreeting')"
					/>
					<div
						class="free-products__user-name"
						v-sanitize="userFullName"
					/>
				</div>
			</template>
			<template v-else-if="hasFeature('FEATURE_ACCOUNT') || hasFeature('FEATURE_ACCOUNT_LOGGEDIN')">
				<div class="free-products__login">
					<span
						class="free-products__login-hint"
						v-html="$t('freeproducts.userLoginHint')"
					/>
					<Button
						level="primary"
						:text="$t('freeproducts.userLoginButton')"
						type="button"
						small
						@click.prevent="openLogin"
					/>
				</div>
			</template>


			<template v-if="promotionsEnhanced.length">

				<GeneralMessage
					v-if="response.message"
					:message="response.message"
					:type="response.type"
					ref="message"
					@close="response.message = ''"
				/>

				<h3
					class="free-products__subtitle"
					v-html="$t('freeproducts.productsTitle')"
				/>
				<ul class="free-products__promotions">
					<li
						v-for="promotion in promotionsEnhanced"
						:key="promotion.code"
						class="free-products__promotion"
						:class="{
							'free-products__promotion--multi': promotion.products.length > 1,
							'free-products__promotion--gone': promotion.left <= 0
						}"
					>
						<div
							class="free-products__promotion-products"
							:class="{
								'free-products__promotion-products--multi': promotion.products.length > 1
							}"
						>
							<div
								v-for="product in promotion.products"
								:key="product.code"
								class="free-products__promotion-product"
							>
								<img
									class="products__item-label"
									v-if="productLabel(product)"
									:src="productLabel(product)"
									loading="lazy"
								>
								<div class="free-products__promotion-product-image">
									<figure class="products__item-image-wrapper">
										<img
											class="products__item-image-element"
											:src="product.image"
											:alt="product.name"
											loading="lazy"
										>
									</figure>
								</div>
								<h4
									class="free-products__promotion-product-name"
									:class="{
										'free-products__promotion-product-name--no-variant': !product.variant.name
									}"
									v-html="product.name"
								/>
								<h5
									v-if="product.variant.name"
									class="free-products__promotion-product-variant"
									v-html="product.variant.name"
								/>
								<div
									v-if="product.shortDescription || product.description"
									class="free-products__promotion-product-description"
									v-html="product.shortDescription || product.description"
								/>
							</div>
						</div>
						<div
							class="free-products__promotion-available"
							:class="{
								'free-products__promotion-available--multi': promotion.products.length > 1
							}"
							v-html="$t('freeproducts.productsAvailable', { count: Math.max(promotion.left, 0) })"
						/>
						<FormInputCheckbox
							class="free-products__promotion-checkbox"
							:value="promotion.code"
							:checked="selectedPromotionCode === promotion.code"
							:disabled="promotion.left <= 0"
							@input="setPromotion(promotion, $event)"
						/>

					</li>
				</ul>

				<Button
					level="primary"
					:text="$t('freeproducts.sendButton')"
					type="button"
					@click.prevent="onSubmit"
					:disabled="loading || !selectedPromotionCode"
				/>
			</template>

		</template>
		<template v-else-if="loaded && !notFound">
			<h2
				class="free-products__title text-block__title"
				v-html="$t('freeproducts.success.title')"
			/>
			<div
				class="free-products__text text-block__text"
				v-html="$t('freeproducts.success.text')"
			/>

			<h2
				class="free-products__subtitle"
				v-html="$t('freeproducts.success.productTitle')"
			/>

			<ul class="free-products__promotions">
				<li
					class="free-products__promotion"
					:class="{
						'free-products__promotion--multi': selectedPromotion.products.length > 1
					}"
				>
					<div
						class="free-products__promotion-products"
						:class="{
							'free-products__promotion-products--multi': selectedPromotion.products.length > 1
						}"
					>
						<div
							v-for="product in selectedPromotion.products"
							:key="product.code"
							class="free-products__promotion-product"
						>
							<img
								class="products__item-label"
								v-if="productLabel(product)"
								:src="productLabel(product)"
								loading="lazy"
							>
							<div class="free-products__promotion-product-image">
								<figure class="products__item-image-wrapper">
									<img
										class="products__item-image-element"
										:src="product.image"
										:alt="product.name"
										loading="lazy"
									>
								</figure>
							</div>
							<h4
								class="free-products__promotion-product-name"
								:class="{
									'free-products__promotion-product-name--no-variant': !product.variant.name
								}"
								v-html="product.name"
							/>
							<h5
								v-if="product.variant.name"
								class="free-products__promotion-product-variant"
								v-html="product.variant.name"
							/>
							<div
								v-if="product.description"
								class="free-products__promotion-product-description"
								v-html="product.description"
							/>
						</div>
					</div>
				</li>
			</ul>

			<Button
				level="primary"
				:text="$t('freeproducts.success.homeButton')"
				type="button"
				@click.prevent="onHome"
			/>
		</template>
		<template v-else>
			<h2
				class="free-products__title text-block__title"
				v-html="$t('freeproducts.notfound.title')"
			/>
			<div
				class="free-products__text text-block__text"
				v-html="$t('freeproducts.notfound.text')"
			/>
			<Button
				level="primary"
				:text="$t('freeproducts.success.homeButton')"
				type="button"
				@click.prevent="onHome"
			/>
		</template>

	</div>
</template>

<script>
import Vue from "vue"
import GenericMixin from '@/mixins/GenericVueMixin';
import { mapGetters } from "vuex"

import Button from '@/components/Button'
import GeneralMessage from '@/components/GeneralMessage'
import FormInputCheckbox from "@/components/FormInputCheckbox"
import htmlComponent from 'htmlcomponent'
import {eventhub, EVENT_ACCOUNT_ISLOGGEDIN} from '@/store/eventhub'

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		Button,
		GeneralMessage,
		FormInputCheckbox,
	},
	props: {},
	data() {
		return {
			promotionCodes: this.$root.options.promotionCodes,
			contentId: this.$root.options.contentId,
			introTitle: this.$root.options.introTitle,
			introText: this.$root.options.introText,
			selectedPromotionCode: null,
			response: {
				type: 'info',
				message: '',
			},
			showSuccess: false,
			notFound: false,
			loaded: false,
		}
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
			"accountUserDetail",
		]),
		...mapGetters("freeproducts", [
			"promotions"
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		userFullName() {
			return `${this.accountUserDetail.firstName} ${this.accountUserDetail.lastName}`;
		},
		promotionsEnhanced() {
			return this.promotions.map((promotion, i) => {
				return {
					...promotion,
					products: promotion.products.slice(0,2).map(product => {
						const image = product.images?.find(image => image.code == 'shopmanager_product');

						return {
							...product,
							image: image ? image.path : product.images?.length && product.images[0].path || '',

							variant: {
								...product.variant,
								name: product.variant.name !== product.name ? product.variant.name : null,
							},
						}
					})
				}
			});
		},
		selectedPromotion() {
			return this.selectedPromotionCode
				? this.promotionsEnhanced.find(p => p.code === this.selectedPromotionCode)
				: null;
		}
	},
	methods: {
		openLogin() {
			htmlComponent.send('overlay:open', {type: 'login'});
		},
		async onIsLoggedIn() {
			this.response.type = 'info';
			this.response.message = '';
			await this.loadPromotions()
		},
		onError(message = '') {
			this.response.type = 'error';
			this.response.message = message;

			if (message) {
				this.$nextTick(() => {
					this.$refs.message.scrollTo();
				});
			}
		},
		productLabel(product) {
			if (product?.attributeIcon) {
				return this.themeImagePath(`attr-icon-${product.attributeIcon}.svg`);
			}
		},
		setPromotion(promotion, checked) {
			if (!this.isLoggedIn) {
				this.onError(this.$t('freeproducts.errorUser'));
			}
			if (checked) {
				this.selectedPromotionCode = promotion.code;
			}
			else {
				this.selectedPromotionCode = null;
			}
		},
		async onSubmit() {
			if (!this.isLoggedIn) {
				return this.onError(this.$t('freeproducts.errorUser'));
			}

			if (!this.selectedPromotionCode) {
				return this.onError(this.$t('freeproducts.errorEmpty'));
			}

			this.onError();

			try {
				this.loading = true;
				await this.$store.dispatch('freeproducts/applyPromotion', { codes: [this.selectedPromotionCode], contaoContentId: this.contentId });
				this.showSuccess = true;
				this.loading = false;
			}
			catch(err) {
        if (err.isMaintenanceError) {
          this.onMaintenanceMode({ callback: () => this.onSubmit(), retry: true })
        } else {
          let error = this.$t('forms.errors.generic');

          if (err?.response?.status === 400) {
            error = this.$t('freeproducts.errorDuplicate');
          }

          this.onError(error);
        }

				this.loading = false;
			}
		},
		onHome() {
			this.$store.dispatch('redirect', {name: 'home'});
		},
		async loadPromotions() {
			this.loading = true
			try {
				await this.$store.dispatch('freeproducts/loadPromotions', { promotionCodes: this.promotionCodes })
				if (!this.promotions.length) {
					this.notFound = true
				}
			}
			catch (err) {
        if (err.isMaintenanceError) {
          this.onMaintenanceMode({ callback: () => this.loadPromotions(), retry: true })
        } else {
				  this.notFound = true
        }
			}
			this.loaded = true
			this.loading = false
		}
	},
	async created() {
		await this.loadPromotions();
	},
	mounted() {
		eventhub.$on(EVENT_ACCOUNT_ISLOGGEDIN, this.onIsLoggedIn)
	},
	destroyed() {
		eventhub.$off(EVENT_ACCOUNT_ISLOGGEDIN, this.onIsLoggedIn)
	}
}
</script>

<style>

</style>
